// extracted by mini-css-extract-plugin
module.exports = {"container":"jt","title":"ju"};